import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import memoize from 'lodash/memoize';
import { Settings as LuxonSettings } from 'luxon';
import en from './en';
import es from './es';

const resources = { en, es };

const FALLBACK_LANG = 'en';

function detectLanguage() {
  /**
   * navigator.language should work fine in all modern browsers including IE11+.
   * See https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/language
  */
  if (!navigator.language) return FALLBACK_LANG;

  const candidateLanguage = navigator.language.split('-')[0];
  return resources[candidateLanguage] ? candidateLanguage : FALLBACK_LANG;
}

i18n
  .use(initReactI18next)
  .on('languageChanged', (lng) => {
    LuxonSettings.defaultLocale = lng;
  })
  .init({
    resources,
    lng: detectLanguage(),
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

const translate = memoize(
  (key, config) => i18n.t(key, config),
  (key, config) => (config ? key + JSON.stringify(config) : key),
);

export default translate;
